import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconCollapseNav(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fill="currentColor"
        d="M20 7a1 1 0 1 0-2 0v10a1 1 0 1 0 2 0V7ZM4.293 11.293a1 1 0 0 0 0 1.414l3 3a1 1 0 0 0 1.414-1.414L7.414 13H15a1 1 0 1 0 0-2H7.414l1.293-1.293a1 1 0 0 0-1.414-1.414l-3 3Z"
      />
    </BaseIcon>
  );
}
